import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
  FormGroup,
  FormBuilder
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import { validateHorizontalPosition } from '@angular/cdk/overlay';
import { GeneralService } from '../services/general.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map } from "rxjs/operators";
import { DataSource } from '@angular/cdk/collections';
import { ArrayType } from '@angular/compiler';
import Swal from 'sweetalert2';
// import { IDropdownSettings } from 'ng-multiselect-dropdown';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}




@Component({
  selector: 'app-addassignuser',
  templateUrl: './addassignuser.component.html',
  styleUrls: ['./addassignuser.component.css']
})


export class AddAssignUserComponent implements OnInit {
  @ViewChildren(MatTable) matTables : QueryList<MatTable<any>>;
  // dropdownSettings :IDropdownSettings;

  selectedmodules: any[] = [];
  modules: any[] = [];
  DepartmentList: any[]=[];
  AllBranchs:any[]=[]
object: any = [{
  companyname: '',
     email: '',
    type: '',
   status: '',
    action: ''
}]

dataSource: any;

  module: any;

  jobFormControl = new FormControl('', [Validators.required]);
  NameFormControl= new FormControl('',[Validators.required])
  ModulesFormControl = new FormControl('', [Validators.required]);
  CategoriesFormControl=new FormControl('', [Validators.required]);
  DepartmentFormControl=new FormControl('', [Validators.required]);
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  matcher = new MyErrorStateMatcher();
  form = {
    name:'',
    job: '',
    email: '',
    module: '',
    cat: '',
    department:'',
    branch:'',
    mobile:''
  };
  // cat: any[] = ['infra', 'clean', 'machine', 'employers'];
  modulesname: any[] = ['pool', 'aquawater', 'foodsaftey'];

  displayedColumns: string[] = ['name', 'email','mobile', 'action'];
  data: object[] = [];
  cats: any[]=[];
  editmode= false;
  assignid: any;
  assigns: any;
  assignstofilter: any;
  catsandmodule: any[]=[];
  id: any;
  currentuser: any;
  department: any[] = [];
  cat: any[] = [];
  i: any;
  AddAssignerForm: any;
  DepartmentForEdit: any[] = [];
  update: boolean;
  BranchList: any[]=[];
  BranchListForEdit: any[] = [];
  ClientData: any;


  constructor(private _formBuilder: FormBuilder,public GeneralService: GeneralService,  private changeDetectorRefs: ChangeDetectorRef) {
    // this.dropdownSettings = {
    //   singleSelection: false, 
    //   idField: 'id',
    //   textField: 'name',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true
    // };
    this.ClientData=JSON.parse(localStorage.getItem('ClientData'))
    const user=  localStorage.getItem("userid")
    console.log(user,"ClientdashboardId");
        if(user){
          this.id=user;
          localStorage.setItem("userid",this.id);
          console.log("Come From Admin")
        }
        else {
          this.currentuser=JSON.parse(localStorage.getItem("currentuser"))
          this.id=this.currentuser.clientid
          console.log("Come From Login")
        }
  }
  GetAllBranchs(){
    this.GeneralService.getBranchByClientId(this.id).then(res=>{
      this.AllBranchs=res;
    })
    }

  ngOnInit() {
    this.AddAssignerForm = this._formBuilder.group({
      Name: [ '', Validators.required],
      Email: ['', Validators.required],
      Mobile:['',Validators.required],
      Departemnts:[[],Validators.required],
      Branchs:[[],Validators.required]
    });
    this.dataSource=[];
    this.getallassign();
    this.getalldepartment();
    this.GetAllBranchs();
  }

  applyFilter(event) {
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    this.assigns = this.assignstofilter.filter((ele: any) => {
      return ele.job.toLowerCase().includes(event.toLowerCase());
    });
  }
getalldepartment(){
  this.GeneralService.getallDepartment().then(res=>{
    console.log(res)
    this.department=res;
    console.log( this.department)
  })
}
  getvalue() {
    console.log(this.modules[this.form.module])
    console.log(this.form.cat.length)
    console.log(this.form.module.length)

if(this.form.cat.length!=0&&this.form.module.length!=0){
    console.log(this.catsandmodule)
    console.log(this.cats)
     if (this.cats.includes(this.modules[this.form.module].name+'   /   '+this.cat[this.form.cat].name) == false) {
    this.cats.push(this.modules[this.form.module].name+'   /   '+this.cat[this.form.cat].name);
    this.catsandmodule.push({"displayname":this.modules[this.form.module].name+'   /   '+this.cat[this.form.cat].name,"modulename":this.modules[this.form.module].name,"catname": this.cat[this.form.cat].name});
    }
  }
  else{
    Swal.fire({
      title: 'Warning!',
      text: 'Please Choose Module And Category',
      icon: 'error'
    })    }
  }
  removeitem(item) {
    console.log(this.catsandmodule.findIndex(x=>x==item))
    let index= this.catsandmodule.findIndex(x=>x==item)
    this.catsandmodule.splice(index, 1);
    let index2= this.cats.findIndex(x=>x==item)
    this.cats.splice(index2, 1);
  }
  get fc() {
    return this.AddAssignerForm.controls;
  }
  AddAssigner(){
    console.log(this.AddAssignerForm.value)
    
    if (this.AddAssignerForm.status == "VALID") {
      if (this.update == true) {
        this.Updateassignuser()
      } 
      else {
        this.InsertAssigner()
      }
    }
     else {
      this.AddAssignerForm.markAllAsTouched();
    }
  }
     Updateassignuser(){
     
  this.AddAssignerForm.get('Departemnts').value.forEach(element => {
    this.DepartmentList.push(element)
  });
  this.AddAssignerForm.get('Branchs').value.forEach(element => {
    this.BranchList.push(element)
  });
  let CountryCode
  if(this.ClientData.country=='Egypt'){
    CountryCode='+20'
  }
  else if(this.ClientData.country=='Saudi Arabia'){
    CountryCode='+966'
  }
  let data = {
    clientid:this.id,
    name:this.AddAssignerForm.get('Name').value,
    email:this.AddAssignerForm.get('Email').value,
    mobile:CountryCode+this.AddAssignerForm.get('Mobile').value,
    departmentid:  this.DepartmentList ,
    branchesid:this.BranchList,
    role: "assign",
  };
console.log(this.cats)
let OldEmail;
const assingerEmail = this.assigns.filter(x=>x.id==this.assignid)[0].email
  if(assingerEmail==this.AddAssignerForm.get('Email').value){
    OldEmail=assingerEmail
  }
  else{
    OldEmail=null
  }
  this.GeneralService.updateassignuser(data,this.assignid,OldEmail).then(res=>{
    Swal.fire({
      icon: "success",
      title: "Success Update assignee",
      showConfirmButton: false,
      timer:1000
    });
    this.getallassign()
        this.AddAssignerForm.reset();
    this.DepartmentForEdit=[]
    this.BranchListForEdit=[]
    this.update=false
 }).catch(error=>{
  // alert("This Email Registerd Befor")
   alert(error)
   });
  



  }
  InsertAssigner() {
  this.AddAssignerForm.get('Departemnts').value.forEach(element => {
    this.DepartmentList.push(element)
  });
  this.AddAssignerForm.get('Branchs').value.forEach(element => {
    this.BranchList.push(element)
  });
  let CountryCode
  if(this.ClientData.country=='Egypt'){
    CountryCode='+20'
  }
  else if(this.ClientData.country=='Saudi Arabia'){
    CountryCode='+966'
  }
    let data = {
      clientid:this.id,
      name:this.AddAssignerForm.get('Name').value,
      email:this.AddAssignerForm.get('Email').value,
      mobile:CountryCode+this.AddAssignerForm.get('Mobile').value,
      departmentid:  this.DepartmentList ,
      branchesid:this.BranchList,
      role: "assign",
    };
console.log(data)
  console.log("true")
  this.GeneralService.addassignuser(data).then(res=>{
    console.log(res)
    Swal.fire({
      icon: "success",
      title: "Success ِAdd assignee",
      showConfirmButton: false,
      timer:1000
    });
    this.getallassign();
    this.matTables.toArray().forEach(each => each.renderRows());
    this.AddAssignerForm.reset();
    this.DepartmentForEdit=[]
    this.BranchListForEdit=[]
    this.DepartmentList =[];
    this.BranchList 
 }).catch(error=>{
  // alert("This Email Registerd Befor")
   alert(error)
   });
  

  }
  delete(element) {
    console.log(element)
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then( (result) => {
      if (result.isConfirmed) {
       this.GeneralService.DelUser(element.id).subscribe(async success => {
        if (success) {
          try {
            await this.GeneralService.deleteUserFromAuth(element.email);
            Swal.fire({
              icon: "success",
              title: "Success User Deleted",
              showConfirmButton: false,
              timer:1000
            });
            this.getallassign(); // Call this only if the user was successfully removed
          } catch (error) {
            console.error("Error deleting user from Auth:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "User deleted from database but failed to delete from authentication",
            });
          }
          
        } else {
          console.log("User could not be removed due to quota limits or other errors.");
        }
      });
     
      }
    })
  
    
  }
  getallassign(){
    this.assigns=[];
    this.assignstofilter=[];

    this.GeneralService.getallAssign(this.id).then(assigns=>{
      assigns.map(res=>{
        console.log(res)
        if(res.mobile){
          res.mobile=res.mobile.replace(/^\+20|\+966/, '');

        }
      })
      this.assigns=assigns;
    
      // this.assignstofilter=assigns
    })
  }
  edit(element){
     this.editmode=true;
     this.update=true
     this.DepartmentForEdit=[]
     this.BranchListForEdit=[]
     element.mobile=element.mobile.replace(/^\+20|\+966/, '');
     this.AddAssignerForm.get("Name").setValue(element.name)
     this.AddAssignerForm.get("Email").setValue(element.email)
     this.AddAssignerForm.get("Mobile").setValue(element.mobile)
     element.departmentid.forEach((element2) => {
       const department = this.department.filter((x) => x.id == element2);
       this.DepartmentForEdit.push(department[0].id);
     }); 

     element.branchesid.forEach(element3 => {
      const branch = this.AllBranchs.filter((x) => x.id == element3);
      this.BranchListForEdit.push(branch[0].id);
     });
     console.log(this.DepartmentForEdit)
     this.AddAssignerForm.patchValue({
      Departemnts:this.DepartmentForEdit
    })
    this.AddAssignerForm.patchValue({
      Branchs:this.BranchListForEdit
    })
    //this.selectedmodules=element.module
    this.assignid=element.id
    console.log(element)
  }
}
